<template lang="pug">
.sync-message
  button.sync-message-toggle(type="button", :aria-expanded="fullResponse", @click="fullResponse = !fullResponse") {{ i18n.messages[currentLocale].showFullResponse }}
  .sync-message-text {{ displayValue }}
</template>

<script setup>
import { computed, ref, watch } from "vue";
import i18n from "@/plugins/vue-i18n";
import { currentLocale } from "@/services/useLocales";

const props = defineProps({
  value: { type: [Object, Array, String], default: null },
});

const fullResponse = ref(false);
const displayValue = computed(() => {
  if (fullResponse.value) return props.value ?? "";

  return props.value?.errors?.error?.message?.value || props.value?.error?.message?.value || "";
});

watch(
  () => props.value,
  () => {
    fullResponse.value = false;
  },
);
</script>

<style scoped lang="scss">
.sync-message {
  word-break: break-word;
}

.sync-message-toggle {
  padding: 0;
  border: none;
  background: none;
  color: gray;
  font: inherit;
  font-size: 12px;
  text-align: left;
  cursor: pointer;
}
</style>
